import PropTypes from 'prop-types';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { MenuItem, Select } from '@mui/material';
import localStyles from './UploadHistoryPagination.module.scss';

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

function UploadHistoryPagination({
  currentPage,
  pageSize,
  totalPages,
  totalElements,
  currentRowsCount,
  onPageChange,
  onPageSizeChange,
}) {
  if (!totalElements) return null;

  const startRow = currentPage * pageSize + 1;
  const endRow = currentRowsCount
    ? currentPage * pageSize + currentRowsCount
    : Math.min((currentPage + 1) * pageSize, totalElements);
  const isPreviousDisabled = currentPage <= 0;
  const isNextDisabled = currentPage >= totalPages - 1;

  return (
    <div className={localStyles.pagination_container}>
      <div className={localStyles.page_size_container}>
        <span className={localStyles.page_size_label}>Rows Per Page</span>
        <Select
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
          variant="standard"
          disableUnderline
          className={localStyles.page_size_select}
          classes={{
            select: localStyles.page_size_select_input,
            icon: localStyles.page_size_select_icon,
          }}
          MenuProps={{
            PopoverClasses: { paper: localStyles.page_size_menu },
          }}>
          {PAGE_SIZE_OPTIONS.map((option) => (
            <MenuItem
              key={option}
              value={option}
              classes={{ root: localStyles.page_size_menu_item }}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div className={localStyles.pagination_actions}>
        <span className={localStyles.page_range}>
          {`${startRow}-${endRow} of ${totalElements}`}
        </span>
        <div className={localStyles.arrow_buttons}>
          <button
            type="button"
            className={localStyles.arrow_button}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={isPreviousDisabled}
            aria-label="Go to previous page">
            <ChevronLeftIcon fontSize="small" />
          </button>
          <button
            type="button"
            className={localStyles.arrow_button}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={isNextDisabled}
            aria-label="Go to next page">
            <ChevronRightIcon fontSize="small" />
          </button>
        </div>
      </div>
    </div>
  );
}

UploadHistoryPagination.propTypes = {
  currentPage: PropTypes.number,
  pageSize: PropTypes.number,
  totalPages: PropTypes.number,
  totalElements: PropTypes.number,
  currentRowsCount: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
};

UploadHistoryPagination.defaultProps = {
  currentPage: 0,
  pageSize: 10,
  totalPages: 0,
  totalElements: 0,
  currentRowsCount: 0,
};

export default UploadHistoryPagination;
